import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowchevronUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="arrowchevron_up_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M481.835 353.835a42.667 42.667 0 0 1 60.33 0l256 256a42.667 42.667 0 0 1-60.33 60.33L512 444.331 286.165 670.165a42.667 42.667 0 0 1-60.33-60.33l256-256z"
    />
  </svg>
);
export default SvgArrowchevronUpIcon;
